var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "customers_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-clients-(green)",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#37DC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customers_selected",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.9991898 C0,17.978605 0.802681769,16.0406835 2.23148103,14.6118843 C3.66027077,13.1831802 5.5981256,12.3804508 7.61873898,12.3804508 C9.63932379,12.3804508 11.5772453,13.1831802 13.0060445,14.6118843 C14.4347486,16.0406835 15.237478,17.978605 15.237478,19.9991898 L0,19.9991898 Z M7.61873898,11.4281085 C4.46172401,11.4281085 1.90468474,8.8710692 1.90468474,5.71405423 C1.90468474,2.55703927 4.46172401,0 7.61873898,0 C10.7757539,0 13.3327932,2.55703927 13.3327932,5.71405423 C13.3327932,8.8710692 10.7757539,11.4281085 7.61873898,11.4281085 Z M14.6308359,13.554689 C16.0875388,13.9290548 17.3891051,14.7534976 18.3500185,15.9105935 C19.3110272,17.0676895 19.8824326,18.4984887 19.983,19.9991898 L17.1421627,19.9991898 C17.1421627,17.5135762 16.1898203,15.2508108 14.6308359,13.554689 Z M12.7042472,11.3871577 C13.5023102,10.6733771 14.14057,9.79893637 14.5771238,8.82130931 C15.0136775,7.84364415 15.238716,6.78476324 15.237478,5.71405423 C15.2394779,4.41264981 14.9066342,3.13260643 14.2708505,1.99706195 C15.3494734,2.21380556 16.3198151,2.79738191 17.0169297,3.6486141 C17.7139491,4.49983676 18.0946955,5.56618403 18.0945055,6.66639661 C18.0947908,7.34491198 17.9499395,8.01563719 17.6698556,8.63362168 C17.3897717,9.25162521 16.9807407,9.80255527 16.4703804,10.2495848 C15.9599249,10.6966143 15.359854,11.029458 14.7102612,11.2256405 C14.0607637,11.421823 13.3767914,11.4768684 12.7042472,11.3871577 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersSelected);
export default __webpack_public_path__ + "static/media/customers_selected.2d51a26f40c90bdfa7ad224616ef6b56.svg";
export { ForwardRef as ReactComponent };